

import NavBar from "./Subcomponents/NavBar";
export default function Resume() {    return <div className="center">
        <NavBar />
        <div className="page-title">resume</div>

        <div className="mt-3 mb-5 larger-body">please <a href="/contact" target="_blank" className="unlink highlight-tq">contact me</a> if you'd like a copy of my resume</div>
        </div>
}